import React from "react";
import { observer } from "mobx-react";
import { MusicalGenreCreateStore } from "../../store";
import { MusicalGenreCreateForm } from "./MusicalGenreCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type MusicalGenreCreateProps = {
  musicalGenreCreateStore: MusicalGenreCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const MusicalGenreCreate: React.FC<MusicalGenreCreateProps> = observer(
  ({ musicalGenreCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={musicalGenreCreateStore.isSaving} />
        <MusicalGenreCreateForm
          musicalGenreCreateStore={musicalGenreCreateStore}
          nameError={musicalGenreCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            musicalGenreCreateStore.setNameValue(value);
          }}
          name={musicalGenreCreateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={musicalGenreCreateStore.isProcessing}
          onSave={() => musicalGenreCreateStore.saveNewMusicalGenre()}
          onCancel={() => musicalGenreCreateStore.cancelNewMusicalGenre()}
        />
        <ErrorDialog
          open={musicalGenreCreateStore.errorDialogOpened}
          title={musicalGenreCreateStore.errorTitle}
          description={musicalGenreCreateStore.errorDescription}
          onClose={() => musicalGenreCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
